import React, { Component } from 'react';

class FeatureRight extends Component {
    constructor(props){
        super(props);
        this.state = {
            collRight: [
                {
                    id: 1,
                    icon: 'fa fa-check',
                    // Actualizado: texto genérico → descripción más precisa
                    title: 'Diplomado en Contabilidad Gubernamental',
                    text: 'Especialización en normativas y sistemas contables del sector público, con enfoque en armonización y rendición de cuentas.'
                },
                {
                    id: 2,
                    icon: 'fa fa-check',
                    // Actualizado: texto genérico → descripción más precisa
                    title: 'Diplomado en Finanzas Públicas',
                    text: 'Formación especializada en el análisis y gestión de las finanzas públicas, presupuesto basado en resultados y política fiscal.'
                },
                {
                    id: 3,
                    icon: 'fa fa-check',
                    // Actualizado: texto genérico → agrega referencia a CONAC, COI y NOI (CV)
                    title: 'Talleres y Cursos en Armonización Contable',
                    text: 'Formación continua en la aplicación de la Ley General de Contabilidad Gubernamental y estándares del CONAC. Incluye cursos en COI, NOI y fiscalización.'
                },
                {
                    id: 4,
                    icon: 'fa fa-check',
                    // Agregado: diplomado del CV no incluido anteriormente
                    title: 'Diplomado en Igualdad de Género — Universidad Iberoamericana',
                    text: 'Formación en perspectiva de género aplicada a la gestión pública. Actualmente en curso.'
                }
            ]
        }
    }

    render() {
        return (
            <div className="topic-items">
                {
                    this.state.collRight.map((data,i)=> (
                        <div className="topic-item" key={i}>
                            <div className="icon-box">
                                <i className={data.icon}></i>
                            </div>
                            <div className="topic-content">
                                <h4>{data.title}</h4>
                                <p>{data.text}</p>
                            </div>
                        </div>
                    ))
            }
            </div>
        );
    }
}

export default FeatureRight;
